import React, { useMemo } from "react";
import { init } from "./SystemOneApp";
import { Outlet } from "react-router";
import DefaultProviders from "./DefaultProviders";

const SystemOneLoginApp = (props: React.PropsWithChildren<any>) => {
  useMemo(() => {
    init();
  }, []);

  return <DefaultProviders>
    <div id="pagecontainer">
      <div id="contentholder">
        <Outlet />
        {props.children}
      </div>
    </div>
  </DefaultProviders>;
}

export default SystemOneLoginApp;